// Custom JS code here

$(document).ready(function() {
    $("#google-merchantwidget-iframe-wrapper").css({
        "right": "10px",
        "bottom": "10px"
    });
});
